import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.href
      ? { '@id': `https://huangyou.com${item.href}`, name: item.label }
      : { name: item.label },
  }));

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-400 py-3 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center">
            {index > 0 && <span className="breadcrumb-separator"></span>}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  );
}